import type { ApprovalChain } from '../approval-chain.model';

export const DEED_OF_GRANT_CHAIN: ApprovalChain = {
  id: 'deed-of-grant',
  label: 'Deed of Grant (Local Government route)',
  applicationTypes: ['DEED_OF_GRANT'],
  archive: { role: 'LOCAL_GOVERNMENT_TECHNICIAN', from: ['SUBMITTED', 'QUERIED', 'RESUBMITTED'] },
  steps: [
    { role: 'LOCAL_GOVERNMENT_TECHNICIAN', action: 'Recommend', from: ['PENDING_REVIEW'], to: 'REVIEWED' },
    { role: 'LOCAL_GOVERNMENT_ESTATE_OFFICER', action: 'Recommend', from: ['FINANCE_APPROVED', 'REVIEWED', 'EXEMPTED', 'RESUBMITTED'], to: 'ESTATE_OFFICER_APPROVED' },
    { role: 'LOCAL_GOVERNMENT_DIRECTOR', action: 'Approve', from: ['REVIEWED', 'ESTATE_OFFICER_APPROVED'], to: 'LOCAL_GOVERNMENT_APPROVED' },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['LOCAL_GOVERNMENT_APPROVED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_APPROVED' },
    { role: 'SURVEYOR_GENERAL_TECHNICIAN', action: 'Recommend', from: ['REGISTRAR_APPROVED'], to: 'SG_TECHNICIAN_RECOMMENDED' },
    { role: 'SURVEYOR_GENERAL', action: 'Approve', from: ['SG_TECHNICIAN_RECOMMENDED'], to: 'APPROVED' },
  ],
};
